import Head from 'expo-router/head';
import { ScrollView } from 'react-native';
import { getTokenValue, YStack } from 'tamagui';

import TrialPassSection from '@/components/TrialPassSection';
import PSText from '@/components/ui/PSText';
import type { PerkUsage } from '@/src/api/authApi';

const capped = (label: string, bookings: number, limit: number): PerkUsage => ({
  label,
  bookings,
  canBook: bookings < limit,
  isUnlimited: false,
  limit,
  remaining: limit - bookings,
});

const PREVIEWS: {
  id: string;
  label: string;
  expiresAt: string | null;
  perks: PerkUsage[];
}[] = [
  {
    id: 'design',
    label: 'The design reference — one capped perk',
    expiresAt: '2026-11-04T12:21:47.971608Z',
    perks: [capped('Events with special perks', 1, 2)],
  },
  {
    id: 'used-up',
    label: 'Allowance used up',
    expiresAt: '2026-11-04T12:21:47.971608Z',
    perks: [capped('Events with special perks', 2, 2)],
  },
  {
    id: 'several',
    label: 'Several perks, one unlimited, one long label',
    expiresAt: '2026-11-04T12:21:47.971608Z',
    perks: [
      capped('Events with special perks', 0, 2),
      {
        label: 'Previews',
        bookings: 3,
        canBook: true,
        isUnlimited: true,
      },
      capped('Secret Menus and other members-only experiences', 1, 1),
    ],
  },
  {
    id: 'no-perks',
    label: 'No perks block (non-active status) and no expiry',
    expiresAt: null,
    perks: [],
  },
];

export default function TrialPassSectionPreview() {
  return (
    <>
      <Head>
        <title>TrialPassSection · Putting Scene</title>
      </Head>
      <ScrollView
        style={{
          flex: 1,
          backgroundColor: getTokenValue('$color.brandDark', 'color'),
        }}
      >
        <YStack gap="$xl" p="$lg">
          {PREVIEWS.map((preview) => (
            <YStack key={preview.id} gap="$sm">
              <PSText.Body3 color="$textWhiteMuted">
                {preview.label}
              </PSText.Body3>
              <TrialPassSection
                expiresAt={preview.expiresAt}
                perks={preview.perks}
                onUpgrade={() => {}}
              />
            </YStack>
          ))}
        </YStack>
      </ScrollView>
    </>
  );
}
